// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1Sv7U","checkboxCol":"Table_checkboxCol__2h6L8","emailCol":"Table_emailCol__26c7i","actionCol":"Table_actionCol__2n509"};